import React, { useState } from "react";

function CompSecuAddemp() {
  const [employee, setEmployee] = useState({
    employeeId: "EMP-" + Date.now(), // Auto-generated
    employeeName: "",
    contactNumber: "",
    email: "",
    address: "",
    gstId: "",
    bankDetails: "",
    status: "Active",
    role: "",
    permissions: [], // changed to array for multi-select
    mfaEnabled: false,
  });

  const handleChange = (e) => {
    const { name, type, checked, value, options } = e.target;
    if (name === "permissions" && type === "select-multiple") {
      const values = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
      setEmployee((prev) => ({ ...prev, [name]: values }));
    } else if (type === "checkbox") {
      setEmployee((prev) => ({ ...prev, [name]: checked }));
    } else {
      setEmployee((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Employee Saved:", employee);
    alert("Employee saved successfully!");
  };

  const styles = {
    container: {
      padding: "30px",
      background: "#f9fafb",
      borderRadius: "12px",
      margin: "20px auto",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    },
    row: {
      display: "flex",
      gap: "20px",
      marginBottom: "20px",
      flexWrap: "wrap",
    },
    formGroup: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
    },
    label: {
      marginBottom: "6px",
      fontSize: "14px",
      fontWeight: "600",
      color: "#374151",
    },
    input: {
      padding: "12px 14px",
      borderRadius: "8px",
      border: "1.5px solid #d1d5db",
      fontSize: "14px",
      backgroundColor: "#ffffff",
      transition: "all 0.2s ease",
    },
    button: {
      marginTop: "20px",
      padding: "12px 24px",
      background: "linear-gradient(90deg, #16a34a, #15803d)",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      boxShadow: "0 4px 10px rgba(22,163,74,0.3)",
    },
  };

  return (
    <div style={styles.container}>
      <h2
        style={{
          fontSize: "22px",
          marginBottom: "20px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        Employee Master Form
      </h2>

      <form onSubmit={handleSubmit}>
        {/* Row 1 */}
        <div style={styles.row}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Employee ID</label>
            <input
              type="text"
              name="employeeId"
              value={employee.employeeId}
              readOnly
              style={{ ...styles.input, background: "#f3f4f6", cursor: "not-allowed" }}
              placeholder="Auto-generated"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Employee Name</label>
            <input
              type="text"
              name="employeeName"
              value={employee.employeeName}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter employee name"
              required
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Contact Number</label>
            <input
              type="text"
              name="contactNumber"
              value={employee.contactNumber}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter contact number"
            />
          </div>
        </div>

        {/* Row 3 */}
        <div style={styles.row}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              name="email"
              value={employee.email}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter email"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Address</label>
            <input
              type="text"
              name="address"
              value={employee.address}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter address"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Status</label>
            <select
              name="status"
              value={employee.status}
              onChange={handleChange}
              style={styles.input}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        {/* Row 5 */}
        <div style={styles.row}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Bank / Payment Details</label>
            <input
              type="text"
              name="bankDetails"
              value={employee.bankDetails}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter bank or payment details"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Role</label>
            <input
              type="text"
              name="role"
              value={employee.role}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter role"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Permissions</label>
            <select
              name="status"
              value={employee.status}
              onChange={handleChange}
              style={styles.input}
            >
              <option value="Active">Read</option>
              <option value="Inactive">Write</option>
              <option value="Inactive">Approve</option>
            </select>
          </div>
        </div>

        {/* Row 6 */}
        <div style={styles.row}>
          
         
          <div style={styles.formGroup}>
            <label style={styles.label}>MFA Enabled</label>
            <label
              style={{
                display: "inline-block",
                position: "relative",
                width: "40px",
                height: "24px",
                marginTop: "10px",
              }}
            >
              <input
                type="checkbox"
                name="mfaEnabled"
                checked={employee.mfaEnabled}
                onChange={handleChange}
                style={{ opacity: 0, width: 0, height: 0 }}
              />
              <span
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: employee.mfaEnabled ? "#4caf50" : "#ccc",
                  borderRadius: "24px",
                  transition: ".4s",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  height: "18px",
                  width: "18px",
                  left: employee.mfaEnabled ? "18px" : "4px",
                  bottom: "3px",
                  backgroundColor: "white",
                  borderRadius: "50%",
                  transition: ".4s",
                  boxShadow: "0 0 2px rgba(0,0,0,0.2)",
                }}
              />
            </label>
          </div>
        </div>

        <div>
          <button type="submit" style={styles.button}>
            Save Employee
          </button>
        </div>
      </form>
    </div>
  );
}

export default CompSecuAddemp;
